// utils/dates.js
// Shared date helpers for the workflow modal and workbench screens.
//
// Date-only strings ('2026-08-31', typical for EAV date metadata) must be parsed as LOCAL dates:
// new Date('2026-08-31') is UTC midnight, which toLocaleDateString renders as the previous day in
// any western timezone (a published_date of 8/31 displayed as "through 8/30"). Full timestamps
// pass through new Date() unchanged.
export const parseDate = (d) => {
  if (d instanceof Date) return d;
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(d);
  return m ? new Date(+m[1], m[2] - 1, +m[3]) : new Date(d);
};

export const formatDate = (d) => d ? parseDate(d).toLocaleDateString() : '';

// Value for <input type="date"> — keeps the stored day regardless of timezone.
export const formatDateInput = (d) => {
  if (!d) return '';
  const dt = new Date(d);
  if (isNaN(dt.getTime())) return d;
  return dt.toISOString().slice(0, 10);
};

export const daysBetween = (a, b) => {
  if (!a || !b) return null;
  const ms = parseDate(b).getTime() - parseDate(a).getTime();
  return Math.max(0, Math.ceil(ms / (1000 * 60 * 60 * 24)));
};

// Sum of hold days overlapping [intervalStart, intervalEnd] (intervalEnd defaults to now).
// Hold rows carry full timestamps; the interval bounds may be date-only metadata strings.
export const totalHoldDaysWithinInterval = (holds, intervalStart, intervalEnd) => {
  if (!intervalStart) return 0;
  const start = parseDate(intervalStart);
  const end = intervalEnd ? parseDate(intervalEnd) : new Date();
  let total = 0;
  for (const h of holds) {
    const hs = new Date(h.started_at);
    const he = h.ended_at ? new Date(h.ended_at) : new Date();
    const overlapStart = hs > start ? hs : start;
    const overlapEnd = he < end ? he : end;
    if (overlapEnd > overlapStart) {
      total += (overlapEnd.getTime() - overlapStart.getTime()) / (1000 * 60 * 60 * 24);
    }
  }
  return Math.ceil(total);
};
